import Link from "next/link";
import { useRouter } from "next/router";

import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { twMerge } from "tailwind-merge";

import { faListUl } from "@fortawesome/free-solid-svg-icons/faListUl";

import FontAwesomeIcon from "components/FontAwesomeIcon";

type Props = {
  onToggle: any;
  isCompact: boolean;
  showPager?: boolean;
  className?: string;
  mutate?: any;
  setSize?: any;
};

const ListModeToggle = ({
  onToggle,
  isCompact,
  showPager,
  mutate,
  setSize,
  className,
}: Props) => {
  const router = useRouter();
  const { page: rawPage, ...restOfQuery } = router.query;
  const page = rawPage && parseInt(rawPage as string);

  const buttonClassName = twMerge(
    "text-shady-gray text-[17px] leading-[1]",
    "bg-transparent border-0"
  );
  const buttonActiveClassName = "text-smart-teal";

  return (
    <span className={className}>
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip>{isCompact ? "Disable" : "Enable"} Condensed View</Tooltip>
        }
      >
        <button
          aria-label="compact view"
          onClick={() => onToggle(!isCompact)}
          className={twMerge(
            buttonClassName,
            isCompact && buttonActiveClassName
          )}
        >
          <FontAwesomeIcon icon={faListUl} />
        </button>
      </OverlayTrigger>
      {showPager && (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip>{page ? "Disable" : "Enable"} Pagination</Tooltip>}
        >
          <Link
            aria-label="pagination view"
            href={{
              pathname: router.pathname,
              query: page
                ? restOfQuery
                : {
                    ...(router.query || {}),
                    page: 1,
                  },
            }}
            onClick={() => setSize(1)}
            className={twMerge(
              !!page ? buttonActiveClassName : "text-shady-gray",
              "ml-[5px]"
            )}
          >
            <svg
              className={twMerge(
                "pb-[5px]",
                !!page ? "!fill-smart-teal" : "!fill-shady-gray"
              )}
              height={15}
              width={30}
              viewBox="-1.05 35.06 100.916 29.75"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M12.525,39.725C6.851,39.725,2.25,44.325,2.25,50c0,5.674,4.601,10.275,10.275,10.275S22.8,55.674,22.8,50  C22.8,44.325,18.2,39.725,12.525,39.725z M12.525,58.275c-4.563,0-8.275-3.712-8.275-8.275s3.712-8.275,8.275-8.275  c4.563,0,8.274,3.712,8.274,8.275S17.088,58.275,12.525,58.275z M36.914,39.725c-5.675,0-10.275,4.6-10.275,10.275  c0,5.674,4.601,10.275,10.275,10.275S47.189,55.674,47.189,50C47.189,44.325,42.589,39.725,36.914,39.725z M36.914,58.275  c-4.563,0-8.275-3.712-8.275-8.275s3.712-8.275,8.275-8.275s8.275,3.712,8.275,8.275S41.478,58.275,36.914,58.275z M61.303,39.725  c-5.674,0-10.274,4.6-10.274,10.275c0,5.674,4.601,10.275,10.274,10.275c5.675,0,10.275-4.601,10.275-10.275  C71.578,44.325,66.978,39.725,61.303,39.725z M85.692,39.725c-5.675,0-10.275,4.6-10.275,10.275c0,5.674,4.601,10.275,10.275,10.275  S95.967,55.674,95.967,50C95.967,44.325,91.367,39.725,85.692,39.725z M85.692,58.275c-4.563,0-8.275-3.712-8.275-8.275  s3.712-8.275,8.275-8.275c4.563,0,8.274,3.712,8.274,8.275S90.255,58.275,85.692,58.275z" />
            </svg>
          </Link>
        </OverlayTrigger>
      )}
    </span>
  );
};

export default ListModeToggle;
